// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"cde6ce54","601":"94f7329b","686":"1a68ab4c"}[chunkId] + ".chunk.js";
};